<ng-container #slideTemplate>
  <div class="vm-carousel-slide">
    <div class="vm-carousel-slide__media">
      <vm-media
        [source]="media?.src | mediaSrcStrapi : strapiUrl"
        [mediaType]="media?.mediaType"
        [aspectRatio]="media?.aspectRatio"
        [altText]="media?.alt"
      ></vm-media>
    </div>

    <div class="vm-carousel-slide__wrapper">
      <div class="vm-carousel-slide__content">
        <div class="vm-carousel-slide__title">
          <p class="Body-Bold">
            <b>{{ title }}</b>
          </p>
        </div>

        <div class="vm-carousel-slide__subtitle">
          <h4>{{ subtitle }}</h4>
        </div>

        <div class="vm-carousel-slide__description">
          <p class="Body">
            <markdown ngPreserveWhitespaces>
              {{ description }}
            </markdown>
          </p>
        </div>

        <div class="vm-carousel-slide__link" *ngIf="actions[0]?.uid">
          <p class="Body">
            <a (click)="openModalOrNextStep($event, actions[0]?.uid)" class="modal-link Body---Link">
              {{ actions[0]?.label }}</a
            >
          </p>
        </div>
      </div>
      <div class="vm-carousel-slide__navigation">
        <vm-carousel-navigation
          [nextCopy]="nextCopy"
          [prevCopy]="prevCopy"
          (nextButtonClick)="onNext()"
          (prevButtonClick)="onPrev()"
        ></vm-carousel-navigation>
      </div>

      <div class="carousel__modal">
        <vm-modal
          *ngIf="issecondaryModalOpen"
          [modalType]="modalType"
          [title]="modal?.modalTitle"
          [hideHeader]="false"
          (closeButtonClick)="issecondaryModalOpen = false"
        >
          <markdown ngPreserveWhitespaces>
            {{ modal?.modalCopy }}
          </markdown>
          <vm-confirmation [nextActions]="modal?.modalActions" (next)="onModalNext($event)"></vm-confirmation>
        </vm-modal>
      </div>
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>
